// extracted by mini-css-extract-plugin
export default {"list":"ContactPage_list__KTtus"};